import { useFetch } from "react-admin-base";
import { Link, useParams } from "react-router-dom";
import { CardHeader } from "reactstrap";
import { CardTitle } from "reactstrap";
import { CardBody } from "reactstrap";
import { Card } from "reactstrap";
import { Col } from "reactstrap";
import { Row } from "reactstrap";

import Levels from '../../data/levels.json';
import Topics from "../../data/topics.json";
import Sports from "../../data/sports.json";
import { useUser } from "../../Components/UserProvider";
import { MentorEdit } from "../../profile/Mentor";
import { UserCover } from "../../Components/Avatar";
import { useReducer } from "react";
import { Modal } from "reactstrap";
import { ModalBody, ModalHeader } from "reactstrap";
import VideoPlayerBig from "../../Components/VideoPlayer";
import { FormattedMessage } from "react-intl";

const TopicsAndSports = Topics.concat(Sports);

function SingleVideoPreview({ value }) {
	const [ isOpen, toggle ] = useReducer(a => !a, false);
	
	return <div className="video-preview-box" onClick={toggle}>
		{ isOpen && <Modal isOpen size="lg" toggle={toggle}>
			<ModalHeader toggle={toggle}>
				{value.title}
			</ModalHeader>
			<VideoPlayerBig
				value={value.file.video}
			/>
		</Modal>}
		<img className="mb-2" src={value.file.video.pictures[value.file.video.pictures.length - 1].link} />
		<b>{value.title}</b>
		<p>
			{ value.description }
		</p>
	</div>;
}

export function List({ data, title, icon, value }) {
	if (!value || !value.map)
		return null;
	
	return <>
		<h2 className="btn btn-sm d-block btn-primary topic"><i className={"fas fa-" + icon} /> <FormattedMessage id={title} /></h2>
		<ul>
			{ value.filter(a => data.find(b => b.id == a)).map(a => <li key={a}>{data.find(b => b.id == a).name}</li>) }
		</ul>
	</>;
}

export function MentorPage({ id }) {
	const [ mentor ] = useFetch('/mentor/' + id);
	const user = useUser();
	
	if (!mentor)
		return null;
	
	return <>
		<UserCover user={mentor.user} />
		<Row>
			<Col md="6">
				<Card>
					<CardBody className="d-flex flex-column">
						<h2>{ mentor.user.name }</h2>
						
						<p className="mb-0">
							<i className="fas fa-envelope" /> <a href={"mailto:" + mentor.user.email}>{mentor.user.email}</a>
						</p>
						
						{ mentor.linkedin_profile && <p>
							<i className="fab fa-linkedin" /> <a href={mentor.linkedin_profile} target="_blank" rel="noopener">{mentor.linkedin_profile}</a>
						</p> }
						
						<div>
							<p>
								{ mentor.about }
							</p>
						</div>
						
						<Row>
							{ id != user.id && <Col>
								<Link to={"/chat/" + mentor.user.id} className="btn btn-primary d-block">
									<i className="fas fa-comments" /> <FormattedMessage id="SEND_MESSAGE" />
								</Link>
							</Col> }
							{ (id == user.id || user.type === 512) && <Col>
								<Link to={id == user.id ? "/profile" : "/mentor/" + mentor.user.id + "/edit"} className="btn btn-primary d-block">
									<i className="fas fa-pencil-alt" /> <FormattedMessage id="EDIT_PROFILE" />
								</Link>
							</Col> }
						</Row>
					</CardBody>
				</Card>
			</Col>
			<Col md="6">
				<Card>
					<CardBody>
						<List
							icon="chart-area"
							data={Levels}
							title="FOCUS_AREA"
							value={mentor.focus_area_ids}
						/>
						
						<List
							icon="vial"
							data={TopicsAndSports}
							title="EXPERT"
							value={Object.entries(mentor.assessments).filter(a => TopicsAndSports.find(b => b.id == +a[0])).filter(([,s]) => s >= 5).map(a => a[0])}
						/>
						
						<List
							icon="snowboarding"
							data={TopicsAndSports}
							title="SKILLED"
							value={Object.entries(mentor.assessments).filter(a => TopicsAndSports.find(b => b.id == +a[0])).filter(([,s]) => s > 2 && s < 5).map(a => a[0])}
						/>
					</CardBody>
				</Card>
			</Col>
		</Row>
		{ mentor.videos.length > 0 && <Card>
			<CardHeader>
				<h2 className="btn btn-sm d-block btn-primary topic mb-0"><i className="fas fa-play-circle" /> Videos</h2>
			</CardHeader>
			<CardBody className="pt-0">
				<Row className="mt-0">
				{
					mentor.videos.map(a => <Col key={a.id} md="3"><SingleVideoPreview value={a} /></Col>)
				}
				</Row>
			</CardBody>
		</Card> }
	</>;
}

export function MentorEditPage() {
	const { id } = useParams();
	
	return <MentorEdit
		id={id}
	/>;
}

export default function Mentor() {
	const { id } = useParams();
	return <MentorPage id={id} />;
}
